module.exports = __webpack_public_path__ + "media/images/webpage/shared/no_image/no_avatar-228c4c99d4e8cba55e8a5a8ef4f43f6a.svg";